var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.745,
    height: 18.39,
    viewBox: "0 0 16.745 18.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 16.745,
    height: 18.39,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5344",
    "data-name": "Path 5344",
    d: "M15.676,9.719h-1.6a2.3,2.3,0,0,0-4.481,0H1.265a.515.515,0,1,0,0,1.029H9.592a2.3,2.3,0,0,0,4.481,0h1.6a.515.515,0,1,0,0-1.029m-3.845,1.786A1.272,1.272,0,1,1,13.1,10.234a1.272,1.272,0,0,1-1.272,1.272",
    transform: "translate(-0.098 -1.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5345",
    "data-name": "Path 5345",
    d: "M15.676,9.719h-1.6a2.3,2.3,0,0,0-4.481,0H1.265a.515.515,0,1,0,0,1.029H9.592a2.3,2.3,0,0,0,4.481,0h1.6a.515.515,0,1,0,0-1.029Zm-3.845,1.786A1.272,1.272,0,1,1,13.1,10.234,1.272,1.272,0,0,1,11.831,11.505Z",
    transform: "translate(-0.098 -1.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5346",
    "data-name": "Path 5346",
    d: "M1.265,3.565H2.659a2.3,2.3,0,0,0,4.48,0h8.536a.515.515,0,1,0,0-1.029H7.14a2.3,2.3,0,0,0-4.48,0H1.265a.515.515,0,1,0,0,1.029M4.9,1.779A1.272,1.272,0,0,1,6.17,3.051a1.272,1.272,0,0,1-2.54,0A1.272,1.272,0,0,1,4.9,1.779",
    transform: "translate(-0.098 -0.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5347",
    "data-name": "Path 5347",
    d: "M1.265,3.565H2.659a2.3,2.3,0,0,0,4.48,0h8.536a.515.515,0,1,0,0-1.029H7.14a2.3,2.3,0,0,0-4.48,0H1.265a.515.515,0,1,0,0,1.029ZM4.9,1.779A1.272,1.272,0,0,1,6.17,3.051a1.272,1.272,0,0,1-2.54,0A1.272,1.272,0,0,1,4.9,1.779Z",
    transform: "translate(-0.098 -0.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5348",
    "data-name": "Path 5348",
    d: "M15.677,16.9H9.425a2.3,2.3,0,0,0-4.48,0H1.265a.515.515,0,1,0,0,1.029H4.945a2.3,2.3,0,0,0,4.48,0h6.252a.515.515,0,1,0,0-1.029M7.184,18.688a1.272,1.272,0,1,1,1.272-1.272,1.272,1.272,0,0,1-1.272,1.272",
    transform: "translate(-0.098 -1.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5349",
    "data-name": "Path 5349",
    d: "M15.677,16.9H9.425a2.3,2.3,0,0,0-4.48,0H1.265a.515.515,0,1,0,0,1.029H4.945a2.3,2.3,0,0,0,4.48,0h6.252a.515.515,0,1,0,0-1.029ZM7.184,18.688a1.272,1.272,0,1,1,1.272-1.272A1.272,1.272,0,0,1,7.184,18.688Z",
    transform: "translate(-0.098 -1.979)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.7cfd9bbfac6c3f6c5bd57f9bfc65378f.svg";
export { ForwardRef as ReactComponent };